(function()
{
    //Import classes
    var BasePanel = include('springroll.easeljs.BasePanel'),
        Bitmap = include('createjs.Bitmap'),
        SoundButton = include('springroll.easeljs.SoundButton'),
        Container = include('createjs.Container');

    /**
     * Panel contains all of the visual elements for the title state
     * @class CountMeToSheep.TitlePanel
     * @extends springroll.easeljs.BasePanel
     */
    var TitlePanel = function()
    {
        BasePanel.call(this);
    };

    //Super prototype
    var s = BasePanel.prototype;

    //Extend the base panel
    var p = extend(TitlePanel, BasePanel);

    /**
     * Setup the state, this happens on each state entering
     */
    p.setup = function()
    {
        this.background = new Bitmap(images.TitleBackground);

        this.addChild(this.background);

        this.playButton = new SoundButton(images.PlayButton);
        this.addChild(this.playButton);

        // add an image from each spritesheet to get initial image decode lift out of the way
        this.ssPreload = [
            ss.Count_Setup_atlas_,
            ss.Count_Setup_atlas_2, 
            ss.Count_Setup_atlas_3, 
            ss.Count_Counting_atlas_,
            ss.Count_CountingQuick_atlas_,
            ss.Count_CountingEnd_atlas_,
            ss.Count_KeepCounting_atlas_,
            ss.Count_Telly_atlas_,
            ss.Count_SheepThumbs_atlas_,
            ss.Count_Sheep_atlas_,
            ss.Count_Timeouts_atlas_,
            ss.Count_Timeouts_atlas_2,
            ss.Count_Success_atlas_,
            ss.Count_Endings_atlas_,
            ss.Count_Endings_atlas_2,
            ss.Count_Endings_atlas_3,
            ss.Count_SheepStills_atlas_,
            ss.Count_SheepStills_atlas_2,
            ss.Count_SheepStills_atlas_3,
            ss.Count_SheepStills_atlas_4
        ];
        this.loadSprites = [];

        for (var i = 0; i < this.ssPreload.length; i++) {
            var preloadSprite = new createjs.Sprite(this.ssPreload[i]);
            // preloadSprite.y = 780; // hide off screen
            preloadSprite.gotoAndStop(0);
            this.addChild(preloadSprite);
            this.loadSprites.push(preloadSprite);
        }
    };

    /**
     * Un-setup the panel when exiting the state
     */
    p.teardown = function()
    {
        s.teardown.call(this);
        this.background = null;
        this.playButton = null;
    };

    //Assign to namespace
    namespace('CountMeToSheep').TitlePanel = TitlePanel;
}());